export default "__VITE_ASSET__C49rEcwZ__"